// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"a1-z","subtitle":"b1-z","wrapper":"c1-z","leftArrow":"d1-z","rightArrow":"e1-z"};